/* eslint-disable*/
import { Outlet, useLocation } from 'react-router-dom'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import {
  AuthCarouselDesktop,
  AuthCarouselMobile,
  darkGridStyle,
  lightGridStyle,
} from '../Components/Auth/AuthCarousel'
import env from '../env/env'
import { useThemeMode } from '../Provider/ThemeContextProvider'
import { cn } from '../lib/utils'

const LegalFooter = ({ darkMode, flush = false, borders = 'sides' }) => {
  return (
    <div
      className={cn(
        'relative z-10 mt-8 shrink-0 px-4 pt-4 font-IBM',
        borders === 'top'
          ? 'rounded-none border-x-0 border-b-0 border-t'
          : 'rounded-t-[24px] border border-b-0',
        flush ? 'pb-[max(8px,env(safe-area-inset-bottom))]' : 'pb-2',
        darkMode
          ? 'border-[#2a2d45] bg-[#12142a]/80'
          : 'border-[#D3DBEC] bg-[#F6F7FB]/90',
      )}
    >
      <p
        className={cn(
          'text-center text-[10px] font-medium leading-3',
          darkMode ? 'text-black-300' : 'text-black-400',
        )}
      >
        <svg
          width='12'
          height='12'
          viewBox='0 0 24 24'
          fill='none'
          aria-hidden='true'
          className='mr-1 inline-block align-[-2px]'
        >
          <path
            d='M17 8h-1V6a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zm-6-2a2 2 0 1 1 4 0v2h-4V6zm3 9.7V17a1 1 0 1 1-2 0v-1.3a2 2 0 1 1 2 0z'
            fill='currentColor'
          />
        </svg>
        Fabits Capital Services LLP | BSE Member ID 61731 | ARN - 344673 REGISTERED WITH AMFI
      </p>
      <p className='mt-1 text-center text-[10px] font-semibold text-primary-500'>
        <a
          href='https://start.fabits.com/termsandconditions'
          target='_blank'
          rel='noreferrer'
          className='no-underline'
        >
          Terms & Conditions
        </a>
        <span className={cn('mx-1.5', darkMode ? 'text-black-300' : 'text-black-400')}>|</span>
        <a
          href='https://start.fabits.com/privacypolicy'
          target='_blank'
          rel='noreferrer'
          className='no-underline'
        >
          Privacy Policy
        </a>
      </p>
    </div>
  )
}

const LoginContainer = () => {
  const location = useLocation()
  const { darkMode } = useThemeMode()
  const logoSrc = darkMode ? `${env.SVGS}/newlogo.svg` : `${env.SVGS}/newlogo2.svg`
  const isLoginPage = location.pathname === '/login' || location.pathname === '/'
  const isSignUpPage = location.pathname === '/sign-up'
  // OTP + signup sit on the shared themed mobile grid (no light sheet)
  const isFullBleedMobileAuthForm =
    isSignUpPage ||
    location.pathname === '/otp' ||
    location.pathname === '/activate-account-otp' ||
    location.pathname === '/otp-login'

  return (
    <>
      {/* Mobile — themed grid background across full auth flow */}
      <div
        className={cn(
          'relative flex h-[100svh] min-h-[100svh] w-full max-w-full flex-col overflow-hidden lg:hidden',
          darkMode ? 'bg-[#040313]' : 'bg-white',
        )}
      >
        <div
          aria-hidden='true'
          className={cn(
            'pointer-events-none absolute inset-0 z-0',
            darkMode ? 'opacity-70' : 'opacity-100',
          )}
          style={darkMode ? darkGridStyle : lightGridStyle}
        />

        {isLoginPage ? (
          <>
            <div className='relative z-10 flex min-h-0 flex-1 flex-col'>
              <div
                className={cn(
                  'absolute inset-x-0 top-0 z-30 flex h-20 shrink-0 items-center justify-center pt-[env(safe-area-inset-top)]',
                  darkMode
                    ? 'bg-gradient-to-b from-[#040313] via-[#040313]/85 to-transparent'
                    : 'bg-gradient-to-b from-white via-white/85 to-transparent',
                )}
              >
                <img src={logoSrc} alt='fabits' className='h-16' />
              </div>
              <AuthCarouselMobile />
            </div>

            <div
              className={cn(
                'relative z-20 w-full shrink-0 rounded-t-[32px] backdrop-blur-[2px]',
                darkMode
                  ? 'bg-[var(--fb-surface)]/95 shadow-[0_-24px_70px_rgba(4,3,19,0.22)]'
                  : 'bg-white/95 shadow-[0_-24px_70px_rgba(4,3,19,0.12)]',
              )}
            >
              <div className='px-4 pb-0 pt-5'>
                <div className='mx-auto w-full max-w-[390px]'>
                  <Outlet />
                </div>
              </div>
              <LegalFooter darkMode={darkMode} flush />
            </div>
          </>
        ) : (
          <div className='relative z-10 flex h-full min-h-0 w-full flex-col'>
            {!isSignUpPage && (
              <div className='flex shrink-0 items-center justify-center px-4 pb-2 pt-[calc(16px+env(safe-area-inset-top))]'>
                <img src={logoSrc} alt='fabits' className='h-16' />
              </div>
            )}
            <div
              className={`flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden ${
                isSignUpPage ? 'pt-[calc(16px+env(safe-area-inset-top))]' : 'pt-2'
              }`}
            >
              <div
                className={cn(
                  'mx-auto flex w-full max-w-[390px] flex-auto shrink-0 flex-col px-4 pt-4',
                  !isFullBleedMobileAuthForm &&
                    (darkMode
                      ? 'rounded-t-[32px] bg-[var(--fb-surface)]/95 pt-6 shadow-[0_-24px_70px_rgba(4,3,19,0.22)] backdrop-blur-[2px]'
                      : 'rounded-t-[32px] bg-white/95 pt-6 shadow-[0_-24px_70px_rgba(4,3,19,0.12)] backdrop-blur-[2px]'),
                )}
              >
                <div className='flex flex-1 flex-col justify-center pb-4'>
                  <Outlet />
                </div>
              </div>
              <LegalFooter darkMode={darkMode} flush />
            </div>
          </div>
        )}
      </div>

      {/* Desktop — two equal-height columns: carousel | auth */}
      <div
        className={cn(
          'hidden h-screen max-h-screen w-full lg:grid lg:grid-cols-2',
          darkMode ? 'bg-[var(--fb-bg)]' : 'bg-white',
        )}
      >
        <div className='h-full min-h-0 w-full overflow-hidden'>
          <AuthCarouselDesktop />
        </div>
        <div className='relative flex h-full min-h-0 flex-col justify-between overflow-y-auto px-12 pt-12 pb-0'>
          {!isSignUpPage && (
            <div className='my-3 flex justify-end'>
              <img src={logoSrc} alt='Fabits' className='h-16' />
            </div>
          )}
          <div className='flex flex-1 flex-col justify-center'>
            <Outlet />
          </div>
          <div className='-mx-12'>
            <LegalFooter darkMode={darkMode} flush borders='top' />
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginContainer
